import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROUTESPATH } from '@/routes';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center h-full bg-gray-50">
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate(ROUTESPATH.DASHBOARD)}>
            Back to Dashboard
          </Button>
        }
      />
    </div>
  );
};

export default Unauthorized;
